import {FACTIONS} from "../constants/factions";
import {PLAYER_COLORS} from "./colors";
import {PRIMARY_COLOR} from "../styles/constants";
import UNIT_TYPES from "./units";
import {GIANTS_UNIT_MAX_SIZE, GIANTS_UNIT_WIN_POINTS} from "./factions/giants";

export const FACTION_CONFIGS = [{
  id: FACTIONS.HUMANS,
  name: 'Люди',
  description: 'Скидка на политики\nМгновенная активация политик',
  textColor: '#9a9a9a',
  implemented: true,
  priceCrystals: 0,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.INDIGO
  ]
}, {
  id: FACTIONS.ORCS,
  name: 'Орки',
  description: 'Повышенная живучесть отрядов',
  textColor: '#795338',
  implemented: true,
  priceCrystals: 1000,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: FACTIONS.DWARVES,
  name: 'Гномы',
  description: 'Разведка рудников\nУвеличенный урон смежно с горами',
  textColor: '#f2bb42',
  implemented: true,
  priceCrystals: 0,
  originalPriceCrystals: 800,
  unitTypes: [UNIT_TYPES.D6.id, UNIT_TYPES.D10.id, UNIT_TYPES.D20.id, UNIT_TYPES.D4.id],
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED
  ]
}, {
  id: FACTIONS.VENTORY,
  name: 'Вентори',
  description: 'Дополнительный доход\nгильдий и храмов\nСкидка на строительство дорог',
  textColor: '#cd7800',
  implemented: true,
  priceCrystals: 800,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.RED
  ]
}, {
  id: FACTIONS.LEPRECHAUNS,
  name: 'Лепреконы',
  description: 'Кража монет у противников\nУвеличенный базовый доход',
  textColor: '#3dbc00',
  implemented: true,
  priceCrystals: 800,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.RED,
  ]
}, {
  id: FACTIONS.DEMONS,
  name: 'Демоны',
  description: 'Уменьшение урона\nотрядов противника',
  textColor: '#e02f11',
  implemented: true,
  priceCrystals: 1000,
  colors: [
    PLAYER_COLORS.RED,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.LIGHT_GREEN
  ]
}, {
  id: FACTIONS.AQUARS,
  name: 'Аквары',
  description: 'Строительство водоемов\nТелепортация между водоемами\nБонус к урону смежно водоемам',
  textColor: '#40bdaf',
  implemented: false,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: FACTIONS.BEASTMEN,
  name: 'Зверолюди',
  description: 'Ускоренный рост размера отрядов\nДополнительные очки\nза уничтожение отрядов противника',
  textColor: '#af7b6a',
  implemented: true,
  priceCrystals: 1500,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: FACTIONS.DARK_ELVES,
  name: 'Темные эльфы',
  description: 'Увеличенная дальность перемещения\nПроклятье вражеских отрядов',
  textColor: '#7652ae',
  implemented: false,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.RED
  ]
}, {
  id: FACTIONS.TECHNODWARVES,
  name: 'Технодворфы',
  description: 'Изучение технологий\nБыстрый найм катапульт',
  textColor: '#cb913a',
  implemented: false,
  priceCrystals: 3000,
  unitTypes: [UNIT_TYPES.D6.id, UNIT_TYPES.D10.id, UNIT_TYPES.D20.id, UNIT_TYPES.D4.id],
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.LIGHT_GREEN
  ]
}, {
  id: FACTIONS.DRAGONS,
  name: 'Драконы',
  description: 'Летающие отряды\nУскоренный рост отрядов\nУрон по площади',
  textColor: '#bdd1d8',
  implemented: false,
  priceCrystals: 3000,
  unitTypes: [UNIT_TYPES.D20.id],
  unitTypesSpec: {
    [UNIT_TYPES.D20.id]: {
      name: 'Дракон',
      speed: 3,
      isFlying: true,
    }
  },
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: FACTIONS.ELEMENTALS,
  name: 'Элементали',
  description: 'Увеличенное количество действий\nдля строительства\nСкидка на центральные кварталы',
  textColor: '#7bd6ff',
  implemented: true,
  priceCrystals: 1400,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.VIOLET
  ]
}, {
  id: FACTIONS.ELVES,
  name: 'Эльфы',
  description: 'Все отряды могут стрелять\nЗамедленный рост размера\nотрядов на казармах',
  textColor: '#7dd54e',
  implemented: true,
  priceCrystals: 1500,
  unitTypesSpec: {
    [UNIT_TYPES.D6.id]: {
      shootingRange: 4,
    },
    [UNIT_TYPES.D10.id]: {
      shootingRange: 4,
    },
    [UNIT_TYPES.D20.id]: {
      shootingRange: 4,
    },
    [UNIT_TYPES.D8.id]: {
      shootingRange: 4,
    },
    [UNIT_TYPES.D12.id]: {
      shootingRange: 4,
    },
  },
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ]
}, {
  id: FACTIONS.ENLIGHTENED,
  name: 'Просветлённые',
  description: 'Бонус к начальному золоту\nОбмен золота на очки 1 к 1',
  textColor: '#ffd700',
  implemented: true,
  priceCrystals: 1200,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.BLUE
  ]
}, {
  id: FACTIONS.ENTS,
  name: 'Энты',
  description: 'Строительство рощ\nБонусы к дальности перемещения\nи урону смежно с рощами',
  textColor: '#699530',
  implemented: false,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.DARK_GREEN,
    PLAYER_COLORS.RED,
  ]
}, {
  id: FACTIONS.FENIX,
  name: 'Феникс',
  description: 'Единственный летающий отряд\nПерерождение с увеличенными\nуроном и дальностью перемещения',
  textColor: '#ef9b00',
  implemented: false,
  priceCrystals: 3000,
  unitTypes: [UNIT_TYPES.D20.id],
  unitTypesSpec: {
    [UNIT_TYPES.D20.id]: {
      name: 'Феникс',
      isFlying: true,
    }
  },
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PINK,
  ]
}, {
  id: FACTIONS.GIANTS,
  name: 'Великаны',
  description: 'Неограниченный и ускоренный\nрост размера отрядов',
  textColor: '#956d46',
  implemented: true,
  priceCrystals: 2300,
  unitTypes: [UNIT_TYPES.D20.id],
  unitTypesSpec: {
    [UNIT_TYPES.D20.id]: {
      name: 'Великан',
      maxSize: GIANTS_UNIT_MAX_SIZE,
      winPoints: GIANTS_UNIT_WIN_POINTS,
    }
  },
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: FACTIONS.CELECTIALS,
  name: 'Селестиалы',
  description: 'Все отряды летают\nДополнительные кости урона\nв ближнем бою',
  textColor: '#c9c9c9',
  implemented: true,
  priceCrystals: 3000,
  unitTypesSpec: {
    [UNIT_TYPES.D6.id]: {
      isFlying: true,
    },
    [UNIT_TYPES.D10.id]: {
      isFlying: true,
    },
    [UNIT_TYPES.D20.id]: {
      isFlying: true,
    },
    [UNIT_TYPES.D8.id]: {
      isFlying: true,
    },
    [UNIT_TYPES.D12.id]: {
      isFlying: true,
    },
    [UNIT_TYPES.D4.id]: {
      isFlying: true,
    }
  },
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.INDIGO,
  ]
}, {
  id: FACTIONS.GOBLINS,
  name: 'Гоблины',
  description: 'Отряды могут\nрасставлять ловушки\nи разрушать строения противника',
  textColor: '#c2c141',
  implemented: true,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.PURPLE
  ]
}, {
  id: FACTIONS.GREMLINS,
  name: 'Гремлины',
  description: 'Строительство мастерских\nдля найма особых\nотрядов-автоматонов',
  textColor: '#8b9e5f',
  implemented: false,
  priceCrystals: 3000,
  unitTypes: [UNIT_TYPES.D6.id, UNIT_TYPES.D20.id, UNIT_TYPES.D4.id],
  unitTypesSpec: {
    [UNIT_TYPES.D20.id]: {
      name: 'Гремлин-механик',
    },
    [UNIT_TYPES.D20.id]: {
      name: 'Автоматон',
      maxSize: 30,
      speed: 3,
    }
  },
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED
  ]
}, {
  id: FACTIONS.INSECTOIDS,
  name: 'Инсектоиды',
  description: 'Рост отрядов без снабжения\nДополнительное снабжение\nза первое снабжение отряда',
  textColor: '#c2804e',
  implemented: true,
  priceCrystals: 1500,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.CELADON
  ]
}, {
  id: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Гриболюды',
  description: 'Строительство спорами\nПассивный урон смежным\nотрядам противника',
  textColor: '#9978b9',
  implemented: false,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.DARK_GREEN,
  ]
}, {
  id: FACTIONS.RATMEN,
  name: 'Крысолюды',
  description: 'Найм отрядов за снабжение\nУвеличенный урон\nза смежные союзные отряды',
  // Светлее прежнего #6d6d6d: на темных экранах (лобби, магазин, коллекция)
  // название почти сливалось с фоном
  textColor: '#a5a5a5',
  implemented: true,
  priceCrystals: 1600,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: FACTIONS.SPIRITS,
  name: 'Духи',
  description: 'Дополнительный рост отрядов\nсмежно рудникам и руинам\nНе используют монеты',
  textColor: '#9f9f9f',
  implemented: false,
  priceCrystals: 3000,
  unitTypes: [UNIT_TYPES.D10.id],
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.CELADON
  ]
}, {
  id: FACTIONS.SUCCUBES,
  name: 'Суккубы',
  description: 'Соблазнение отрядов противника',
  textColor: '#9d46cb',
  implemented: true,
  priceCrystals: 2100,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.SKY_BLUE
  ]
}, {
  id: FACTIONS.DOPPLERS,
  name: 'Допплеры',
  description: 'Одновременное использование\n2 политик',
  textColor: '#e375a2',
  implemented: false,
  priceCrystals: 3000,
  colors: [
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.CELADON
  ]
}, {
  id: FACTIONS.UNDEAD,
  name: 'Нежить',
  description: 'Уникальные способности отрядов:\nскелеты, призраки, личи,\nвампиры, умертвия',
  textColor: '#b2ad90',
  implemented: false,
  priceCrystals: 3000,
  unitTypesSpec: {
    [UNIT_TYPES.D6.id]: {
      name: 'Скелеты',
    },
    [UNIT_TYPES.D10.id]: {
      name: 'Личи',
    },
    [UNIT_TYPES.D20.id]: {
      name: 'Умертвия',
      speed: 3,
      isFlying: true,
    },
    [UNIT_TYPES.D8.id]: {
      name: 'Призраки',
      isFlying: true,
    },
    [UNIT_TYPES.D12.id]: {
      name: 'Вампиры',
      isFlying: true,
    },
  },
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: FACTIONS.WIZARDS,
  name: 'Маги',
  description: 'Карты заклинаний\nСпециальные строения\nдля усиления заклинаний',
  textColor: '#1774d9',
  implemented: false,
  priceCrystals: 3000,
  unitTypesSpec: {
    [UNIT_TYPES.D6.id]: {
      name: 'Маги',
      price: 3,
    },
  },
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.PINK,
  ]
}]

export const FACTION_CONFIGS_IMPLEMENTED = FACTION_CONFIGS.filter(config => config.implemented);

export const FACTION_IDS_IMPLEMENTED = FACTION_CONFIGS_IMPLEMENTED.map(config => config.id);

/**
 * Летает ли отряд данного типа у данной фракции - единственный источник
 * правды, откуда gameplay-код (сейчас - резолвер ловушек Гоблинов,
 * resolveMovementWithTraps.js) должен узнавать про полёт, вместо отдельного
 * поля на самом типе отряда (см. add-goblins-faction design.md): "летает ли
 * отряд" - свойство ПАРЫ (тип отряда, фракция), а не одного лишь типа отряда -
 * у Нежити в одной и той же фракции Скелеты/Личи (D6/D10) остаются наземными,
 * а Умертвия/Призраки/Вампиры (D20/D8/D12) летают; у Драконов/Феникса летает
 * их собственный D20, но обычный D20 у остальных фракций - нет. unitTypesSpec
 * до появления этой функции был чисто описательным полем для карусели образов
 * отрядов (FactionUnitSkinsCarousel) - ни одна реальная игровая механика его
 * не читала (см. также shootingRange Эльфов - та же история: реальная
 * дальность стрельбы считается отдельной константой в
 * calculateAvailableShootingCellsForElves.js, а не отсюда)
 */
export const checkIfUnitTypeIsFlyingForFaction = (unitTypeId, factionId) => {
  const factionConfig = FACTION_CONFIGS.find(config => config.id === factionId);
  return Boolean(factionConfig?.unitTypesSpec?.[unitTypeId]?.isFlying);
};

/** Есть ли у фракции летающие отряды: тогда в партии нужны картинки крыльев */
export const checkIfFactionHasFlyingUnits = (factionId) => {
  const factionConfig = FACTION_CONFIGS.find(config => config.id === factionId);
  return Object.values(factionConfig?.unitTypesSpec || {}).some((spec) => spec?.isFlying);
};

// Моковая «фракция» для выбора случайной: НЕ входит в FACTION_UNIT_SKIN_CONFIGS —
// показывается на 0 позиции карусели выбора; при старте игры заменяется
// на случайную из доступных игроку (локально — createPlayersState,
// в сетевых играх — сервер по состоянию игрока в базе)
export const RANDOM_FACTION_ID = 'random_faction';

export const RANDOM_FACTION_CONFIG = {
  id: RANDOM_FACTION_ID,
  name: 'Случайная',
  description: 'Случайная фракция\nиз доступных вам',
  textColor: PRIMARY_COLOR,
  implemented: true,
  imagePath: '/img/other/strategikon_bust.png',
};